import React from 'react';
import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';
const StaticBanner = ({ picture, BannerImg, en_US, ar_SA, arabic }) => {
  const { t } = useTranslation();
  const isActive = useSelector((state) => state.toggle.isActive);

  return (
    // <div className="lg:pt-28 pt-12 ">
    //   <div className="relative w-full ">
    //     <img src={BannerImg} className="w-full h-70vh md:h-80 sm:pb-4" alt="" />
    //     <div className="absolute  top-10 md:top-40 w-full ">
    //       <h2 className={`text-customgreen text-3xl text-center flex w-full justify-center font-bold py-3 `}>
    //         {t(`${arabic ?  isActive ? ar_SA : en_US :en_US }`)}
    //       </h2>
    //     </div>
    //   </div>
    // </div>

    // <div className="lg:pt-18 pt-12" data-aos="zoom-out">
    //   <div className="relative w-full ">
    //     {!picture ? (
    //       <img
    //         src={BannerImg}
    //         className="w-full h-70VH md:h-80 sm:pb-4"
    //         alt={`${arabic ? (isActive ? ar_SA : en_US) : en_US}`}
    //       />
    //     ) : (
    //       <img className="w-full h-70VH md:h-80 sm:pb-4" src={`data:image/jpeg;base64,${picture}`} alt="project Name" />
    //     )}
    //     <div className="absolute inset-0   bg-customgreen opacity-40"></div>
    //     <div className="absolute top-10 md:top-36 w-full">
    //       <h2 className="text-white text-3xl text-center flex w-full justify-center font-bold ">
    //         {t(`${arabic ? (isActive ? ar_SA : en_US) : en_US}`)}
    //       </h2>
    //     </div>
    //   </div>
    // </div>




//     <div className="lg:pt-18 pt-12" data-aos="zoom-out">
//   <div className="relative w-full">
//     {!picture ? (
//       <img
//         src={BannerImg}
//         className="w-full h-70VH md:h-80 sm:pb-4 object-cover"
//         alt={`${arabic ? (isActive ? ar_SA : en_US) : en_US}`}
//       />
//     ) : (
//       <img
//         className="w-full h-70VH md:h-80 sm:pb-4 object-cover"
//         src={`data:image/jpeg;base64,${picture}`}
//         alt="project Name"
//       />
//     )}
//     <div className="absolute inset-0 bg-customgreen opacity-40"></div>
//     <div className="absolute top-[60%] w-full transform -translate-y-1/2">
//       <h2 className="text-white text-xl sm:text-3xl text-center font-bold">
//         {t(`${arabic ? (isActive ? ar_SA : en_US) : en_US}`)}
//       </h2>
//     </div>
//   </div>
// </div>


<div className="lg:pt-18 pt-12" data-aos="zoom-out">
  <div className="relative w-full overflow-hidden"> {/* Added overflow-hidden */}
    {!picture ? (
      <img
        src={BannerImg}
        className="w-full h-70VH md:h-80 object-cover"
        alt={`${arabic ? (isActive ? ar_SA : en_US) : en_US}`}
      />
    ) : (
      <img
        className="w-full h-70VH md:h-80  object-cover"
        // src={`data:image/jpeg;base64,${picture}`} 
        src={`${picture}`}
        alt="project Name"
      />
    )}
    <div className="absolute inset-0 bg-customgreen opacity-50"></div>
    <div className="absolute top-[60%] w-full transform -translate-y-1/2">
      <h2 className="text-white text-xl sm:text-3xl text-center font-bold">
        {t(`${arabic ? (isActive ? ar_SA : en_US) : en_US}`)}
      </h2>
    </div>
  </div>
</div>
  );
};

export default StaticBanner;
